import { twMerge } from 'tailwind-merge';

/* Segmented control. options: [[value, label], …]. Used for Shorts vs
   long-form and the Step-4 visibility picker. */
export default function Segmented({ options, value, onChange, className = '' }) {
	return (
		<div className={twMerge('flex bg-slate-100 rounded-2xl p-[5px] gap-1', className)}>
			{options.map(([key, label]) => {
				const on = value === key;
				return (
					<button
						key={key}
						type="button"
						onClick={() => onChange(key)}
						className={twMerge(
							'flex-1 flex items-center justify-center gap-2 text-sm font-semibold px-4 py-2.5 rounded-xl transition',
							on ? 'bg-white text-slate-800 shadow-small' : 'text-slate-500 hover:text-slate-700'
						)}
					>
						{label}
					</button>
				);
			})}
		</div>
	);
}
